// extracted by mini-css-extract-plugin
module.exports = {"label":"_35LeV","color-sample":"_1xuQr","colorSample":"_1xuQr","disabled":"_2DjQE","input":"_3EX1c"};